import { createContext } from "react";
export const FontSetContext = createContext({
    fontSetId: "modern",
    setFontSetId: () => { },
});
